import React, { FunctionComponent } from 'react';
import Translation from '../../../../../../common/components/translation/Translation';
import LabelAndPrice from '../labels/LabelAndPrice';

interface ISummaryTotalPrice {
  loading?: boolean;
  totalWithOptions: number;
  currency: string;
}

const SummaryBasketTotalPrice: FunctionComponent<ISummaryTotalPrice> = ({ totalWithOptions, currency, loading }) => {
  return (
    <LabelAndPrice
      loading={loading}
      label={<Translation id={'spc.customise.totalPrice'} />}
      price={totalWithOptions}
      boldLabel={true}
      priceType="total"
      currency={currency}
    />
  );
};

export default SummaryBasketTotalPrice;
